exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-wrapper {\n  position: relative; }\n\n.input-filter {\n  width: 90% !important;\n  margin-top: 10px !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important; }\n\n.input-icon {\n  color: #89b1fa;\n  position: absolute;\n  width: -12px;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  margin-left: 33%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-menu/t2-menu.component.scss
// module id = 2153
// module chunks = 66